import React from 'react';
import { StarIcon } from '@heroicons/react/24/solid';

export default function CTA() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="bg-gradient-to-br from-indigo-600 via-indigo-600 to-blue-600 rounded-3xl p-12 lg:p-16 relative overflow-hidden">
          {/* Decorative */}
          <div className="absolute top-0 left-0 w-64 h-64 bg-white/5 rounded-full -translate-x-32 -translate-y-32 pointer-events-none" />
          <div className="absolute bottom-0 right-0 w-48 h-48 bg-white/5 rounded-full translate-x-16 translate-y-16 pointer-events-none" />

          <div className="relative">
            <div className="flex items-center justify-center gap-1 mb-4">
              {[...Array(5)].map((_, i) => (
                <StarIcon key={i} className="w-5 h-5 text-yellow-300" />
              ))}
              <span className="text-white text-sm font-semibold ml-2">4.8 on G2</span>
            </div>
            <h2 className="text-3xl lg:text-4xl font-bold text-white mb-4">
              Try our data quality for free!
            </h2>
            <p className="text-indigo-200 text-lg mb-8 max-w-lg mx-auto">
              Join 40,000+ sales professionals using Director Discovery to find verified leads that actually respond.
            </p>
            <div className="flex flex-col sm:flex-row gap-3 justify-center">
              <a href="#" className="bg-white text-indigo-700 font-bold px-8 py-3.5 rounded-xl text-base hover:bg-indigo-50 transition-colors shadow-lg">
                Get started for free
              </a>
              <a href="#" className="border-2 border-white/40 text-white font-semibold px-8 py-3.5 rounded-xl text-base hover:bg-white/10 transition-colors">
                Contact Sales
              </a>
            </div>
            <p className="mt-4 text-indigo-300 text-xs">No credit card required · 50 free credits to start</p>
          </div>
        </div>
      </div>
    </section>
  );
}
